// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"faq-accordion_sectionTitle__3aanX","faqSection":"faq-accordion_faqSection__glnww"};